"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _styledComponents = _interopRequireDefault(require("styled-components"));

var _Icon = _interopRequireDefault(require("./Icon"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

// Components
const battletanks = 'https://lh3.googleusercontent.com/E3gWztTqJoq5mIz8WlBPxjm3l_n8b2enasFge8pv8wsCvi_ziN_3A_4we2eUyIv5IX-0=s360';
const mousemaze = 'https://is1-ssl.mzstatic.com/image/thumb/Purple118/v4/08/c2/56/08c25678-fb06-453f-7a84-32ff2f86ff49/AppIcon-1x_U007emarketing-85-220-6.png/246x0w.jpg';
const paintbynumber = 'https://lh3.googleusercontent.com/t0i2uJ8F61rVOa2BxopLvfC56h4UQUvqr_Wise9bKqhgdaK90ZZmDfpYDnzclbdqxg=s360';
const sniper3d = 'https://lh3.googleusercontent.com/kOkRAVs7meM9Dn-nVHGnufuZvGm1sWRigG40mcdgXs7Jn6CEDYzYbxrSo6W2zR-DCi8=s360';
const bikerace = 'https://lh3.googleusercontent.com/B_EE8Uh6aHsjnAsoTHOww3-9ai64qA6iSOcAqxd_AnTezbZ8ZMIqRbZjSIykpCqk6wm1=s360';
const flightpilot = 'https://lh3.googleusercontent.com/a8qcgzC7VYpswt_eCEnrQlGb8qnoPo0m4oVIHz81eaqFfo4LrILSj5F27ocEG5GGjA=s360';
const zooba = 'https://lh3.googleusercontent.com/TQ13j3txyvXYGzp2xpEBGLYsypiaxRWFL09Kkp5Wea-PNfmgCOI50N4kUeX63XRoEw=s360';
const ninjarun = 'https://lh3.googleusercontent.com/O5NbRbUGU7etoFcQ5PjG8Xmoamw5M4DkkGpk3mYYlCMevWoxJAv8Wli2qMD4Hgh4mBE=s360';
const iconLogoMap = {
  archeroba: 'https://lh3.googleusercontent.com/czCMG_eXytgTGtEO81z3PtdtFl0ouio9tX10oFS8TSlEa9fzyR55QVil0AW6dIFjKyA=s360',
  archersanddragons: 'https://lh3.googleusercontent.com/v2a_Zo1sxtUHOxX9cCFPvttDgVAW9Cv45kEqqfIbdhRXucxquY5CPw81yLq0D5HDMWg=s360',
  racingclash: 'https://lh3.googleusercontent.com/g2YVliVbvRQkobL4uHKiT_r_JJQrF4k7YAob2awjcmNGvVFhRGxS_k0MzR8O6T8Mvg=s360',
  battletanks,
  battletanksbeta: battletanks,
  bikerace,
  boomforce: 'https://lh3.googleusercontent.com/I8Di99SUizPXVQX8UFfHoFVFss4gDMCbA3swD632WTf6Nq446ZbI_fpnmW72U8pxLbWt=s360',
  blockcraft: 'https://lh3.googleusercontent.com/o1US_4bdFr8LZezyp5IQ0n3yAnmskur9iXxhM4xKFKfiE9k85_PsVd7fs2IiJie2H9Vj=s360',
  colorbynumber: 'https://lh3.googleusercontent.com/E38-fIQw-uLctuYM7n9oQOT7XRWPp5g5M4Ud4SMYcuaReJBgpzmdmBLwa2aYGp75TL7E=s360',
  colorfy: 'https://lh3.googleusercontent.com/ZnDTKhvuehrhf-g9OZd29cQ2YZ8QSN9qYItJMNzhdaQ_wAwspj88cGbOSPIfK3gu1w=s360',
  corpcity: 'https://lh3.googleusercontent.com/EUFxxKJi_4w8MugpIbWpJjyd3jprRnbNdlaRxhCpRYrbbzOqH1TowMlVQe17Vna03Q=s360',
  drawfy: 'https://lh3.googleusercontent.com/wEmzHx1oXYQZ0nyNht-zoMX1nCxWhBfhXEzk0Sbf-0XjLYGu6iYi6zNbgTbOC980vTI=s360',
  epiccardgame: 'https://lh3.googleusercontent.com/mGysDXYcXcyYxoZBx4WBkaYqkvMIcoXon_HVMqEnMssg9cazgRiC5JTyny9n8cvU_SE=s360',
  flightpilot,
  mathapp: 'https://lh3.googleusercontent.com/mMrAa0XjYkugjn3_AzRgSFB1shMcFT-QeQ6zKKJMUtBW8WsapucLVT7jloTYiFTXdA=s360',
  mobileempires: 'https://s3.amazonaws.com/toprr/mobileempires.jpg',
  paintbynumber,
  ninjarun,
  racingpenguin: 'https://lh3.googleusercontent.com/-PEo6F91TR6I9hICT5IUq0Ltjo3eTw7SvTPQp8MMwUIGJKCCRHQd4lHv-aQHkG-UgAo=s360',
  skywarriors: 'https://play-lh.googleusercontent.com/oYEXVYPJtWR-4vul_Tb_196oXTVQYOvy-7mFrByJyuf-LhpkPp0m7EpD9GWPi-O4qEO0=s360',
  sniper3d,
  suspects: 'https://lh3.googleusercontent.com/XVvU4_7WAEdjOPMrrm6Q7-sCaJgl96DqUSdqx6JcLXj7rP5YUed3WYXoCXw02_AtoA',
  overkill: 'https://lh3.googleusercontent.com/o4AwZwavEWty7t1K7uFETTgmFoVQbCetBMHx93bUo7uYgF4zElKResrPUPX1qzArAlo=s360',
  tennisclash: 'https://lh3.googleusercontent.com/Kl3t6kiyaNQ-9_ioFpDeMba-8tQETIV4gQ9uepumixa5sxySfypGwXVfzb0nYAAIZDw=s360',
  zooba,
  snipershooter: 'https://is1-ssl.mzstatic.com/image/thumb/Purple118/v4/2c/e5/5d/2ce55da8-4787-0405-598d-0ff0894e6273/AppIcon-1x_U007emarketing-85-220-6.png/460x0w.webp',
  mousemaze,
  mousemazefree: mousemaze,
  colorfybynumber: paintbynumber,
  sniper3dkr: sniper3d,
  bikeracefree: bikerace,
  filghtpilot: flightpilot,
  zoba: zooba,
  ninjarunfree: ninjarun,
  fp2: flightpilot,
  fp3: flightpilot,
  fp4: flightpilot
};

const getType = type => iconLogoMap[type.toLowerCase()];

const Wrapper = _styledComponents.default.div.withConfig({
  displayName: "AppIcon__Wrapper",
  componentId: "design-system__sc-1xulsh9-0"
})(["line-height:normal;max-width:", ";max-height:", ";cursor:", ";& > img{border-radius:0.25rem;}"], _ref => {
  let {
    size
  } = _ref;
  return "".concat(size, "px");
}, _ref2 => {
  let {
    size
  } = _ref2;
  return "".concat(size, "px");
}, _ref3 => {
  let {
    onClick
  } = _ref3;
  return onClick ? 'pointer' : 'default';
});

const AppIcon = _ref4 => {
  let {
    type,
    size,
    onClick
  } = _ref4;
  const image = getType(type);
  return /*#__PURE__*/_react.default.createElement(Wrapper, {
    size: size,
    onClick: onClick
  }, image ? /*#__PURE__*/_react.default.createElement("img", {
    src: image,
    alt: type,
    title: type.toLowerCase(),
    width: size,
    height: size
  }) : /*#__PURE__*/_react.default.createElement(_Icon.default, {
    type: "appicon",
    size: size,
    title: type.toLowerCase()
  }));
};

AppIcon.propTypes = {
  size: _propTypes.default.string,
  type: _propTypes.default.oneOf(Object.keys(iconLogoMap)).isRequired,
  onClick: _propTypes.default.func
};
AppIcon.defaultProps = {
  size: '50',
  onClick: undefined
};
var _default = AppIcon;
exports.default = _default;